module.exports = __webpack_public_path__ + "img/BannerWeb_3.938ac2d4.png";